import { Box, Heading, Text } from '@chakra-ui/react';
import Slider from '@components/atoms/Slider';
import { fontSize } from '@constants/styles';
import Image from 'next/image';
import React from 'react';
import { testimonialContent } from './content/TestimonialsContent';

const Testimonials = () => {
  return (
    <Box bg="blue.400" borderRadius="10px" position="relative">
      <TestimonialImages />
      <Box p="11%" m="0px auto" w="100%" textAlign="center">
        <Heading className="add-scribble-below" color="white" fontSize={fontSize.h1} backgroundPosition="50% 130%">
          Testimonials
        </Heading>
        <Text textStyle="p_lg" color="white" fontWeight={500} mt={3}>
          Notes from happy customers.
        </Text>
        <Box pt={18}>
          <Slider>
            {Object.keys(testimonialContent).map((obj, i) => (
              <Box key={i}>
                <Text textStyle="p_lg" color="white" fontWeight={500} mt={12} px={[5, 5, '10%']}>
                  {testimonialContent[obj].body}
                </Text>
                <Text textStyle="p" color="white" fontWeight={500} mt={7} mb={[3, 3, 10]}>
                  {testimonialContent[obj].person}
                </Text>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

const TestimonialImages = () => {
  return (
    <Box display={['none', 'block']}>
      <Box position="absolute" left="20px" top="90px" w={['20px', '40px', '60px']} h={['34px', '45px', '57px']}>
        <Image src="/testimonial_top_left_scribble.svg" fill alt="Decorative brushstroke." />
      </Box>
      <Box position="absolute" right={['10px', '20px', '60px']} bottom="-25px" w={['65px', '120px', '150px']} h="70px">
        <Image src="/testimonial_bottom_right_scribble.svg" fill alt="Another decorative brushstroke." />
      </Box>
    </Box>
  );
};

export default Testimonials;
